import { z } from 'zod';
import {
  phoneSchema,
  idSchema,
  objectIdSchema,
  userDeviceSchema,
  AdminUserSchema,
  AdminUser,
  paginationWithSearchSchema,
} from '@hero/schema';
import { API } from '../types';

const baseSchema = AdminUserSchema.model;
//* Admin Send OTP
export const adminSendOTPSchema = baseSchema.pick({ phone: true });
export type AdminSendOtpAPI = API<
  z.infer<typeof adminSendOTPSchema>,
  {
    isNewUser: boolean;
    otpId: string;
    phone: string;
    expiredAt: Date;
  }
>;

//* Admin Verify OTP

export const adminVerifyOTPSchema = z.object({
  phone: phoneSchema,
  code: z.coerce.string().trim(),
  otpId: objectIdSchema,
  deviceToken: userDeviceSchema.shape.token.optional(),
  oneSignalId: idSchema.optional(),
});
export type AdminVerifyOtpAPI = API<
  z.infer<typeof adminVerifyOTPSchema>,
  {
    access_token: string;
    refresh_token: string;
    isNewUser: boolean;
    adminUser: AdminUser | null;
  }
>;

//* Admin Sign Out
export const adminSignOutSchema = z.object({
  deviceToken: userDeviceSchema.shape.token.optional(),
  oneSignalId: idSchema.optional(),
});
export type AdminSignOutAPI = API<z.infer<typeof adminSignOutSchema>, undefined>;

//* Admin Change Language
export const adminChangeLangSchema = baseSchema.pick({
  preferredLanguage: true,
});
export type AdminChangeLangAPI = API<
  z.infer<typeof adminChangeLangSchema>,
  {
    access_token: string;
    refresh_token: string;
    adminUser: AdminUser;
  }
>;

//* Admin Get Me
export type AdminGetMeAPI = API<undefined, z.infer<typeof AdminUserSchema.model>>;

//* Admin Create User
export const adminCreateUserSchema = baseSchema
  .pick({
    name: true,
    phone: true,
    email: true,
    preferredLanguage: true,
    permissions: true,
  })
  .partial({ permissions: true, preferredLanguage: true });

export type AdminCreateUserAPI = API<z.infer<typeof adminCreateUserSchema>, AdminUser>;

export const adminGetAllUsersSchema = paginationWithSearchSchema;
export type AdminGetAllUsersAPI = API<z.infer<typeof adminGetAllUsersSchema>, AdminUser[]>;

//* Admin Update User
export const adminUpdateUserSchema = z
  .object({
    _id: objectIdSchema,
  })
  .merge(
    baseSchema
      .pick({
        name: true,
        email: true,
        preferredLanguage: true,
        permissions: true,
        status: true,
      })
      .partial(),
  );

export type AdminUpdateUserAPI = API<z.infer<typeof adminUpdateUserSchema>, AdminUser>;

//* Admin Get One User
export const adminGetOneUserSchema = z.object({
  _id: objectIdSchema,
});

export type AdminGetOneUserAPI = API<z.infer<typeof adminGetOneUserSchema>, AdminUser>;

//* Admin Delete User
export const adminDeleteUserSchema = z.object({
  _id: objectIdSchema,
});

export type AdminDeleteUserAPI = API<z.infer<typeof adminDeleteUserSchema>, { success: boolean }>;

/** Admin refresh — mirrors network-party `/auth/refresh` with `hero_admin_rt` cookie. */
export const adminRefreshTokenSchema = z.object({
  refreshToken: z.string().optional(),
});
export type AdminRefreshTokenAPI = API<
  z.infer<typeof adminRefreshTokenSchema>,
  {
    access_token: string;
    refresh_token?: string;
  }
>;
